import HeroHexagon from './HeroHexagon';

export default HeroHexagon;
